import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/Typography';
import { formatFiscalNumber } from '@utils/format';
import { RadioButton, RadioButtonProps, RadioButtonType } from '@components/atoms/RadioButton';
import { useData } from '@hooks/useData';

export interface AddressOptionProps {
    radioButton: Pick<RadioButtonProps, 'id' | 'name' | 'value' | 'type' | 'checked' | 'onChange'>;
    uuid?: string;
    name: string;
    lastName?: string;
    fiscalNumber?: string;
    address: string;
    postalCode: string;
    region?: string;
    note?: string;
}

export const AddressOption: FC<AddressOptionProps> = ({
    radioButton,
    name,
    lastName,
    fiscalNumber,
    address,
    postalCode,
    region,
    note,
}) => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        fiscalNumberLabel: t('address-option-component.fiscal-number.label'),
    };

    return (
        <div
            className={`d-flex ${radioButton.type === RadioButtonType.normal && 'align-items-center'} `}
            data-testid="address-option">
            <div className="me-4">
                <RadioButton {...radioButton} />
            </div>
            <div>
                <Typography classes="mb-1" fontWeight="900">
                    <>
                        {name} {lastName || ''}
                    </>
                </Typography>
                {fiscalNumber && (
                    <Typography
                        classes="mb-1"
                        fontSize="14">{`${translations.fiscalNumberLabel}: ${formatFiscalNumber(fiscalNumber)}`}</Typography>
                )}
                <Typography classes="mb-1" fontSize="14">
                    {address}
                </Typography>
                <Typography classes="mb-0" fontSize="14">
                    {postalCode}
                </Typography>
                {region && (
                    <Typography classes="mb-0" fontSize="14">
                        {allSettings?.data?.regions?.find((item) => item.uuid === region)?.name}
                    </Typography>
                )}
                {note && (
                    <Typography classes="mb-0" fontSize="14" color="muted">
                        {note}
                    </Typography>
                )}
            </div>
        </div>
    );
};
